import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useEffect } from 'react'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
const EmployeeRoleSelect = ({ isStatement, setSelectedRole, isMulti }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [isLoading, setLoading] = useState(true)

  const data = [
    {
      id: 1,
      label: t('hooks.employeeRoleSelect.responsible'),

      value: 1,
    },
    {
      id: 2,
      label: t('hooks.employeeRoleSelect.observer'),

      value: 2,
    },
    {
      id: 3,
      label: t('hooks.employeeRoleSelect.coExecutor'),

      value: 3,
    },
    {
      id: 4,
      label: t('hooks.employeeRoleSelect.guarantor'),

      value: 4,
    },
  ]

  const dataStatements = [
    {
      id: 4,
      label: t('hooks.employeeRoleSelect.applicant'),

      value: 4,
    },
    {
      id: 1,
      label: t('hooks.employeeRoleSelect.addressee'),

      value: 1,
    },
  ]
  const animatedComponents = makeAnimated()
  const handleSelect = (dataEmployees) => {
    isMulti
      ? setSelectedRole(dataEmployees.map((employee) => employee.label))
      : setSelectedRole(dataEmployees.label)
  }
  useEffect(() => {
    if (data[0]?.length !== 0) {
      setLoading(false)
    }
  }, [data])

  const selectInfoStyles = {
    width: '100%', 
    zIndex: 9998, 
    maxWidth: '100vh', 
    minWidth: '100vh', 
  };


  const mobileStyles = {
    maxWidth: '100%',
    minWidth: '100%', 
  };
  return (
    <div style={{ ...selectInfoStyles, ...mobileStyles }}>
      <Select
        closeMenuOnSelect={true}
        components={animatedComponents}
        options={isStatement ? dataStatements : data}
        onChange={handleSelect}
        isSearchable={true}
        placeholder={t('hooks.employeeRoleSelect.placeholder')}
        autosize={true}
        isMulti={isMulti ? true : false}
        noOptionsMessage={() => t('hooks.common.noResults')}
        isLoading={isLoading}
      />
    </div>
  )
}

export default EmployeeRoleSelect
